import React from "react";
import { eur } from "../../utils/formatovanie";

const PredcasneSplatenieVystupKarta = React.forwardRef(function PredcasneSplatenieVystupKarta({
  ppOpen,
  ppRezim,
  resultA,
  resultB,
  preplatenieBezPS,
  fmtMesiace,
  rozdielMesiacov,
  exceededRelevant,
  ppDraft,
}, ref) {
  if (!ppOpen) return null;

  return (
    <div ref={ref} className="card-section card-section--pp-vystup">
                <div className="ps-vystup-head">
                  <h2>Predčasné splatenie</h2>
                  <span className="ps-vystup-mode">
                    {ppRezim === 'skratenie' ? '(skrátenie splatnosti)' : '(zníženie splátky)'}
                  </span>
                </div>
    
                {/* Variant A - zníženie splatnosti */}
                {ppRezim === 'skratenie' && (
                  <>
                  
                      <div className="pp-text">
                        <div className="pp-riadky">
                          <div className="pp-riadok">
                            <span className="pp-k">Predčasné splatenie hypotéky:</span>
                            <span className="pp-v">
                              {resultA ? `${fmtMesiace(resultA.payoffMonth)} (m: ${resultA.payoffMonth})` : '-'}
                            </span>
                          </div>   
                          <div className="pp-riadok">
                            <span className="pp-k">Splatené skôr o:</span>
                            <span className="pp-v">
                              {resultA ? rozdielMesiacov(resultA.monthsSaved) : '-'}
                            </span>
                          </div>
                          <div className="pp-riadok">
                            <span className="pp-k">Celkové preplatenie hypotéky bez PS:</span>
                            <span className="pp-v">
                              {`${eur(Math.round(preplatenieBezPS))} €`}
                            </span>
                          </div>
                          <div className="pp-riadok">
                            <span className="pp-k">Celkové preplatenie hypotéky s PS:</span>
                            <span className="pp-v">
                              {resultA ? `${eur(Math.round(resultA.totalInterestPP))} €` : '-'}
                            </span>
                          </div>
                          <div className="pp-riadok sub">
                            <span className="pp-k">úspora:</span>
                            <span className="pp-v">
                              {resultA ? `${eur(Math.round(resultA.usporaNaUrokoch))} €` : '-'}
                            </span>
                          </div>
                        </div>
                      </div>
                    
                  </>
                )}
    
                {/* Variant B - zníženie splátky */}
                {ppRezim === 'znizenie' && (
                  <>
                    <div className="pp-text">
                      <div className="pp-riadky">
                        <div className="pp-riadok">
                          <span className="pp-k">Nová splátka po 1. PS:</span>
                          <span className="pp-v">
                             {resultB ? `${eur(Math.round(resultB.firstNewPayment))} €` : '-'}
                          </span>
                        </div>
                        <div className="pp-riadok">
                          <span className="pp-k">Priemerná splátka:</span>
                          <span className="pp-v">
                            {resultB ? `${eur(Math.round(resultB.avgPayment))} €` : '-'}
                          </span>
                        </div>
                        <div className="pp-riadok">
                          <span className="pp-k">Predčasné splatenie hypotéky:</span>
                          <span className="pp-v">
                            {resultB
                              ? `${fmtMesiace(resultB.payoffMonth)} ${resultB.payoffMonth < (resultB.baselineMonths || 0) ? '' : '(rovnaká lehota)'}`
                              : '-'}
                          </span>
                        </div>
                        <div className="pp-riadok">
                          <span className="pp-k">Splatené skôr o:</span>
                          <span className="pp-v">
                            {resultB
                              ? (() => {
                                  const diff = Math.max(0, (resultB.baselineMonths || 0) - (resultB.payoffMonth || 0));
                                  return rozdielMesiacov(diff);
                                })()
                              : '-'}
                          </span>
                        </div>
                        <div className="pp-riadok">
                          <span className="pp-k">Celkové preplatenie hypotéky bez PS:</span>
                          <span className="pp-v">
                            {`${eur(Math.round(preplatenieBezPS))} €`}
                          </span>
                        </div>
                        <div className="pp-riadok">
                          <span className="pp-k">Celkové preplatenie hypotéky s PS:</span>
                          <span className="pp-v">
                            {resultB ? `${eur(Math.round(resultB.totalInterest))} €` : '-'}
                          </span>
                        </div>
                        <div className="pp-riadok sub">
                          <span className="pp-k">úspora:</span>
                          <span className="pp-v">
                            {resultB ? `${eur(Math.round(resultB.usporaNaUrokoch))} €` : '-'}
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
    
                {ppDraft.length > 0 && (
                <p className={`limit-msg ${exceededRelevant.length ? 'error' : ''}`}>
                  {exceededRelevant.length
                    ? `Prekročenie 30 % limitu bez poplatku v roku: ${
                        [...new Set(exceededRelevant.map((e) => Number(e.year) + 1))].join(', ')
                      }`
                    : 'Ročný 30 % limit bez poplatku nebol prekročený'}
                </p>
                )}
    
              </div>
  );
});

export default PredcasneSplatenieVystupKarta;